'use client'

import { ThemeProvider } from 'next-themes'

export default function Providers({ children }: { children: React.ReactNode }) {
  // @@TODO: In pages/_app.tsx, pass nonce from pageProps to ThemeProvider - we need to do something similar here.
  return <ThemeProvider disableTransitionOnChange>{children}</ThemeProvider>
}
